import script from "./successModal.vue?vue&type=script&setup=true&lang=js"
export * from "./successModal.vue?vue&type=script&setup=true&lang=js"

import "./successModal.vue?vue&type=style&index=0&id=f0d42490&lang=less"

const __exports__ = script;

export default __exports__